import { defineStore } from "pinia";

export const useFroalaStore = defineStore("froala", {
    state: () => ({
        disableFroala: false,
    }),
});
